export const revokeCsvDownloadURL = (responseBlob: Blob, fileName: string) => {
  const url = URL.createObjectURL(responseBlob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${fileName}-${new Date().getTime()}.csv`;
  link.click();
  URL.revokeObjectURL(url);
};
